import { Row } from "@storeblocks/accordion";
import { StyledAlert } from "App/global-style";
import styled from "styled-components";

export const ContentWrapper = styled.div`
  margin-left: 32px;

  .AdviceHeaderText {
    margin-bottom: 16px;
  }
`;

export const OneTimePaymentWrapper = styled.div`
  margin-bottom: 16px;
`;

export const SliderWrapper = styled.div`
  display: flex;
  margin: auto;
  margin-bottom: 32px;
  margin-top: 16px;
  width: 80%;

  /* Prevent text overlap between the "advice-value"-marker and other markers */
  & > .MuiSlider-root > [data-index="2"] {
    @media (pointer: coarse) {
      top: 54px;
    }

    top: 50px;
  }
`;

export const StyledCheckbox = styled.div`
  & label {
    font-size: 18px;

    /* font-weight: 700; */
    font-weight: 600;

    & > *:last-child {
      margin-left: -8px;
    }
  }

  & > div {
    display: flex;
  }
`;

export const PriceLoadingWrapper = styled.div`
  display: flex;
  flex-direction: row;

  & > #ValueSpinner {
    margin-top: 4px;
  }

  & > .ValueType {
    font-size: 14px;
    margin-left: 4px;
    margin-top: 2px;
  }
`;

export const AdditionalAdvices = styled.div`
  margin: 24px 0;
`;

export const UwInlineAlert = styled(StyledAlert)`
  max-width: 500px;
`;

export const StyledRow = styled(Row)`
  & button {
    padding: 16px;
  }

  & section {
    padding: 16px;

    & div > ul {
      padding-left: 16px;
    }
  }
`;

export const AlreadyInsuredWrapper = styled.div`
  margin-bottom: 16px;
`;
